<template>
  <div id="presenter" class="screen">
    Signing in...
  </div>
</template>

<script>
export default {
  name: 'SignInUser'
};
</script>



// WEBPACK FOOTER //
// src/pages/SignInUser.vue